import { Button } from '@mantine/core'
import { IconPlus } from '@tabler/icons-react';
import NotificationDigestItem from './NotificationDigestItem';
import { useLanguage } from '../../../../../stores/LanguageStore';

const NotificationDigest = ({ watched, setWatched, disabled }) => {
    const lang = useLanguage((s) => s.language);
    const addWatched = () => {
        setWatched([...watched, { id: watched.length + 1, status: "opener" }]);
    }

    return (
        <>
            {watched.map((item, index) => (
                <NotificationDigestItem key={item.id} item={item} setWatched={setWatched} disabled={disabled} />
            ))}

            <Button onClick={addWatched} leftSection={<IconPlus />} variant='light' size='md' disabled={disabled}>
                {lang.datafields.create.button_tooltip}
            </Button>
        </>
    )
}

export default NotificationDigest